<div class="c-currency-select d-flex align-items-center">
  <p500-ui-select-field
    [data]="data"
    [formControl]="currencyControl"
    [multiple]="multiple"
    [label]="label"
    [clearable]="clearable"
    p500UITooltip
    placeholder="Choose Currency"
    i18n-placeholder="@@common.choose_currency"
    class="w100"
  >
    <ng-template *ngIf="label" p500UIFieldLabel>
      <span class="p500-ui-form-field__label">
        {{ label }}
      </span>
      <span
        *ngIf="label && showHint"
        class="p500-ui-form-field__hint"
        p500UITooltip
        i18n-tooltipData="@@common.click_for_description"
        tooltipData="Click for description"
        (click)="openTooltipModal()"
        >?</span
      >
    </ng-template>
    <ng-template let-data="data" p500UIFieldTemplate>
      <div class="d-flex align-items-center">
        @let currency = (acceptedCurrencyList || currencyList)[data.key];
        <img [src]="currency.img" [alt]="currency.name" width="16" height="16" />
        <span class="ml-5">{{ currency.code }}</span>
        <span *ngIf="!shortView" class="c-dot-separator c-dot-separator__small ml-5 mr-5 d-inline-block"></span>
        <span *ngIf="!shortView" class="text-color--gray">{{ currency.name }}</span>
      </div>
    </ng-template>
  </p500-ui-select-field>
  <span
    *ngIf="showHint && !label"
    class="c-currency-select__hint"
    p500UITooltip
    i18n-tooltipData="@@common.click_for_description"
    tooltipData="Click for description"
    (click)="openTooltipModal()"
    >?</span
  >
</div>
<div class="text text-color--red p-1" *ngIf="showWarning && currencyControl.dirty && initialValue !== currencyControl.value">
  <span i18n="@@common.warning">WARNING</span>:
  <p class="mb-10" i18n="@@offer_edit.currency_change_warning">
    The new currency will be applied only to the upcoming conversions. The historical data will remain unchanged
  </p>
</div>
